import * as Sentry from "@sentry/react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "@/api.config";
import { QueryKeys } from "@/LinkGen";

export const useProfile = () => {
  const { data, refetch } = useSuspenseQuery({
    queryKey: QueryKeys.Profile(),
    queryFn: async () => {
      const profile = await Api.Profile();

      Sentry.setUser({
        id: profile.id,
        email: profile.email,
      });

      return profile;
    },
  });

  return {
    profile: data,
    refetch,
  };
};
